import { usePagination, UsePaginationProps } from '@/hooks/usePagination';
import './Pagination.css';
import Typo from '../Typo';
import { cn } from '@/src/utils';
import LucideIcon from '../Icons/LucideIcon';

interface Props extends UsePaginationProps {
  onChangePage?: (page: number) => void;
}

const buttonClassName =
  'p-2 min-h-[36px] cursor-pointer flex justify-center items-center mt-1';

const dotClassName = 'p-2  flex justify-center mt-0.5 items-center';
const disabledButtonClassName =
  'p-2  min-h-[36px] flex justify-center items-center ';

const Pagination: React.FC<Partial<Props>> = ({
  page = 1,
  pageSize = 10,
  total = 1,
  limit = 5,
  onChangePage,
}) => {
  const {
    handleClickPrev,
    handleClickNext,
    handleClickPageButton,
    handleClickFirst,
    handleClickLast,
    pages,
    nowPage,
    start,
    lastPage,
  } = usePagination({ page, pageSize, total, limit, onChangePage });

  const renderPage = () => {
    return (
      <>
        {pages.map(pageNumber => (
          <div
            key={pageNumber}
            className={buttonClassName}
            onClick={() => {
              handleClickPageButton(pageNumber);
            }}
          >
            <Typo
              typoType={nowPage === pageNumber ? 'b14sb' : 'b14r'}
              className={
                nowPage === pageNumber
                  ? 'pagination-select'
                  : 'pagination-default'
              }
            >
              {pageNumber}
            </Typo>
          </div>
        ))}
      </>
    );
  };

  return (
    <div className="flex gap-4">
      {total > 0 && (
        <div
          className={page === 1 ? disabledButtonClassName : buttonClassName}
          onClick={handleClickPrev}
        >
          <LucideIcon className="cursor-pointer" name="ChevronLeft" size={20} />
        </div>
      )}

      {start !== 1 && (
        <>
          <div className={buttonClassName} onClick={handleClickFirst}>
            1
          </div>
          <div className={cn(dotClassName, 'text-Gray8')}>•••</div>
        </>
      )}
      {renderPage()}

      {start + limit <= lastPage && (
        <>
          <div className={cn(dotClassName, 'text-Gray8')}>•••</div>
          <div className={buttonClassName} onClick={handleClickLast}>
            {lastPage}
          </div>
        </>
      )}
      {total > 0 && (
        <div
          className={
            page === lastPage ? disabledButtonClassName : buttonClassName
          }
          onClick={handleClickNext}
        >
          <LucideIcon
            className="cursor-pointer"
            name="ChevronRight"
            size={20}
          />
        </div>
      )}
    </div>
  );
};

export default Pagination;
